import { CgOptions } from "react-icons/cg";
import { FaBell, FaLock, FaMobile, FaSync } from "react-icons/fa";
import { IoMdOptions } from "react-icons/io";


export function ChromeInstructions({ isMobile }: { isMobile: boolean }) {
  const instructions =
    isMobile
      ? [
        {
          icon: <FaMobile />, text: <>לחץ על סמל ההגדרות
            <CgOptions className="bg-gray-200 aspect-square rounded-full p-1 text-black inline mx-1" fill="black" size={ "1.5em" } />
            ליד כתובת האתר בשורת הכתובת</>
        },
        { icon: <IoMdOptions />, text: 'בחר ב"הרשאות"' },
        { icon: <FaLock />, text: 'בחר ב "התראות"' },
        { icon: <FaSync />, text: "אפשר הצגת התראות" },
      ]
      : [
        {
          icon: <CgOptions />, text: <>לחץ על סמל ההגדרות
            <CgOptions className="bg-gray-200 aspect-square rounded-full p-1 text-black inline mx-1" fill="black" size={ "1.5em" } />
            ליד כתובת האתר בשורת הכתובת</>
        },
        { icon: <FaBell />, text: 'מצא את האיזור "התראות" ובחר "אפשר"' },
      ]

  return (
    <ol className="space-y-4">
      { instructions.map((instruction, index) => (
        <li key={ index } className="flex items-center space-x-4 rtl:space-x-reverse">
          <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-purple-600 rounded-full text-white">
            { instruction.icon }
          </span>
          <span className="text-gray-200">{ instruction.text }.</span>
        </li>
      )) }
    </ol>
  )
}

